<!-- inner page header html start -->
<header class="bg-image bg-image-inner">
    <nav class="navbar navbar-expand-lg navbar-light fixed-top bg-white shadow">
        <div class="container">
            <a class="navbar-brand" routerLink="/">
                <img src="../../../assets/images/enl-solutions-logo-new.png" class="enl-logo">
            </a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav mr-auto">
                </ul>
                
                <div class="form-inline my-2 my-lg-0">
                        <div class="nav-item dropdown">
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" data-toggle="dropdown">Port-to-Port</a>
                                <div class="dropdown-menu dropdown-menu-right dropdown-info"
                                    aria-labelledby="navbarDropdownMenuLink-4">
                                    <a class="dropdown-item" routerLink='/home'><i aria-hidden="true">
                                        </i> SEARCH</a>
                                    <a class="dropdown-item" routerLink='/raterequestlist'><i aria-hidden="true">
                                        </i>RATE REQUESTS</a>
                                    <a class="dropdown-item" routerLink='/bookinglist'><i aria-hidden="true">
                                        </i>BOOKING REQUESTS</a>
                                </div>
                            </li>
                        </div>
                    
                        <div class="nav-item dropdown">
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" data-toggle="dropdown">Shipment Tracker</a>
                                <div class="dropdown-menu dropdown-menu-right dropdown-info"
                                    aria-labelledby="navbarDropdownMenuLink-4">
                                    <a class="dropdown-item" routerLink='/trackingvoyage'><i aria-hidden="true">
                                        </i> TRACKING</a>
                                </div>
                            </li>
                        </div>
                    
                        <div class="nav-item dropdown">
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" data-toggle="dropdown">PORT ACTIVITIES</a>
                                <div class="dropdown-menu dropdown-menu-right dropdown-info"
                                    aria-labelledby="navbarDropdownMenuLink-4">
                                    <a class="dropdown-item" routerLink='/portcalendar'><i aria-hidden="true">
                                        </i> PORT CALENDAR</a>
                                </div>
                            </li>
                        </div>
                    
                        <!--<div class="nav-item dropdown">
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" data-toggle="dropdown">PORT OPTIMIZER</a>
                                <div class="dropdown-menu dropdown-menu-right dropdown-info"
                                    aria-labelledby="navbarDropdownMenuLink-4">
                                    <a class="dropdown-item" routerLink='#'><i aria-hidden="true">
                                        </i> UNDER DEVELOPMENT</a>
                                </div>
                            </li>
                        </div>-->

                        <div class="nav-item dropdown">
                            <li class="nav-item dropdown" >
                                <a class="nav-link dropdown-toggle" data-toggle="dropdown">MARKET NAVIGATOR</a>
                                <div class="dropdown-menu dropdown-menu-right dropdown-info"
                                    aria-labelledby="navbarDropdownMenuLink-4">
                                    <a class="dropdown-item" routerLink='#'><i aria-hidden="true">
                                        </i> UNDER DEVELOPMENT</a>
                                </div>
                            </li>
                        </div>
                    
                        <div class="nav-item dropdown">
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" data-toggle="dropdown">NEWS</a>
                                <div class="dropdown-menu dropdown-menu-right dropdown-info"
                                    aria-labelledby="navbarDropdownMenuLink-4">
                                    <a class="dropdown-item" routerLink='/news'><i aria-hidden="true">
                                        </i> LATEST NEWS</a>
                                </div>
                            </li>
                        </div>
                   
                    
                    <!-- <li class="nav-item">
                        <a class="nav-link" routerLink="/voyageperformance" routerLinkActive="active">VOYAGE
                            PERFORMANCE</a>
                    </li>  -->
                    <!-- <li class="nav-item">
                        <a class="nav-link" routerLink="/tradeandportintelligence" routerLinkActive="active">Trade & Port Intelligence</a>
                    </li> -->
                   
                    <div class="nav-item dropdown">
                        <li class="nav-item dropdown" *ngIf="isAdmin == true">
                            <a class="nav-link dropdown-toggle" data-toggle="dropdown">Administration</a>
                            <div class="dropdown-menu dropdown-menu-right dropdown-info"
                                aria-labelledby="navbarDropdownMenuLink-4">
                                <a class="dropdown-item" routerLink='/importschedulecsv'><i aria-hidden="true">
                                    </i> IMPORT SCHEDULE CSV</a>
                                <a class="dropdown-item" routerLink='/shippinglines'><i aria-hidden="true">
                                    </i>Shipping Lines</a>
                                <a class="dropdown-item" routerLink='/ports'><i aria-hidden="true">
                                    </i>PORT</a>
                                <a class="dropdown-item" routerLink='/vessels'><i aria-hidden="true">
                                    </i> VESSELS</a>
                                <a class="dropdown-item" routerLink='/users'><i aria-hidden="true">
                                    </i>USERS</a>
                                <a class="dropdown-item" routerLink='/plans'><i aria-hidden="true">
                                    </i>PLANS</a>
                                <a class="dropdown-item" routerLink='/apis'><i aria-hidden="true">
                                    </i>Api's</a>
                                <a class="dropdown-item" routerLink='/opensearch'><i aria-hidden="true">
                                    </i> Open Search Config</a>
                            
                            </div>
                        </li>
                    </div>
                    <button *ngIf="isSignedIn != true" class="btn btn-outline-success btn-sign-in my-2 my-sm-0"
                        type="submit">Sign In</button>
                    <div class="nav-item dropdown">
                        <a data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <img pTooltip="{{userName}}" src="../../../../assets/images/user.png" class="user-icon pr-3"
                                width="60">
                        </a>
                        <a data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <img pTooltip="{{userName}}" src="../../../../assets/images/menu.png" class="user-icon">
                        </a>
                        <p-menu #menu [popup]="true" [model]="user" appendTo="body"></p-menu>
                        <li class="nav-item dropdown">
                            <div class="dropdown-menu dropdown-menu-right dropdown-info"
                                aria-labelledby="navbarDropdownMenuLink-4">
                                <!-- <a class="dropdown-item" routerLink='/profile'><i aria-hidden="true">
                              </i>{{userName}} </a> -->
                                <a class="dropdown-item" routerLink='/planselection'><i aria-hidden="true">
                                    </i>PLAN SELECTION</a>
                                <a class="dropdown-item" *ngIf="isAdmin != true && isSubcription == 3"
                                    (click)="planSubcriptiont(isSubcription)"><i aria-hidden="true">
                                    </i>Subscribe</a>
                                <a class="dropdown-item" *ngIf="isAdmin != true && isSubcription == 1"
                                    (click)="planSubcriptiont(isSubcription)"><i aria-hidden="true">
                                    </i>Unsubscribe</a>
                                <a class="dropdown-item" (click)="signOut()"><i aria-hidden="true">
                                    </i>SIGN OUT</a>
                            </div>
                        </li>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</header>
<!-- inner page header css end -->
